export class SustainabilityEntryModel{
    travel_id: number;
    employee_id : string = '';
    office_id : number;
    attendance_per_week : number;
    distance_unit : string = '';
    transport_mode_id: number = 0;
    distance : number;
    plane_origin_desc: string = '';
    plane_destination_desc: string = '';
    plane_frequency: number = null;
    travel_type: number= 0;
    quarter: string = '';
    year: number = 0;

}